class BorderAppearanceConfig extends BasicAppearanceConfig {
    visible: KnockoutObservable<boolean>;
    shadow: KnockoutObservable<boolean>;

    constructor(data: any, dashboard: Dashboard) {
        super(data, dashboard);

        this.visible = ko.observable(data.visible);
        this.shadow = ko.observable(data.shadow);
    }
}